(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staticless-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.slHeroWaitlistBound) return;
    window.slHeroWaitlistBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest ? event.target.closest('[data-sl-waitlist-form]') : null;
      if (!form) return;
      event.preventDefault();

      var container = form.closest('[data-sl-waitlist]');
      var button = form.querySelector('button[type="submit"]');
      var input = form.querySelector('input[type="email"]');
      var success = container.querySelector('[data-sl-waitlist-success]');
      var error = container.querySelector('[data-sl-waitlist-error]');
      var label = button.getAttribute('data-label');

      error.hidden = true;
      button.disabled = true;
      button.textContent = 'Sending...';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source,
              profile: { data: { type: 'profile', attributes: { email: input.value } } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo request failed: ' + response.status);
          form.hidden = true;
          success.hidden = false;
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = label;
          error.hidden = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
